import React, { useState, useEffect } from 'react';
import { BACKEND_URL } from '../config';
import { Lightning, ArrowRight, Plugs, ArrowsClockwise } from '@phosphor-icons/react';

const TYPE_ICON = {
  integration_connected: Plugs,
  execution_optimised: ArrowsClockwise,
  system_optimised: Lightning,
};

function timeAgo(iso) {
  if (!iso) return '';
  const sec = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (sec < 60) return 'just now';
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  return `${Math.floor(hr / 24)}d ago`;
}

export default function ImprovementFeed({ limit = 5 }) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFeed = async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/api/improvements?limit=${limit}`, { credentials: 'include' });
        if (!res.ok) return;
        const data = await res.json();
        setEvents(data.events || []);
      } catch {
        // silent
      } finally {
        setLoading(false);
      }
    };
    fetchFeed();
  }, [limit]);

  if (loading || events.length === 0) return null;

  return (
    <div data-testid="improvement-feed">
      <h3 className="text-[11px] font-semibold text-[#5C6778] uppercase tracking-wider mb-3">Recent improvements</h3>
      <div className="space-y-2">
        {events.map(event => {
          const Icon = TYPE_ICON[event.type] || Lightning;
          return (
            <div
              key={event.event_id}
              className="flex items-start gap-3 py-2.5 px-3 rounded-xl bg-[rgba(255,255,255,0.02)] border border-[rgba(255,255,255,0.04)]"
              data-testid={`feed-event-${event.event_id}`}
            >
              <div className="w-5 h-5 rounded-full bg-[rgba(0,229,192,0.06)] flex items-center justify-center flex-shrink-0 mt-0.5">
                <Icon size={10} className="text-[#00E5C0]" weight="fill" />
              </div>
              <div className="flex-1 min-w-0">
                {(event.improvements || []).slice(0, 3).map((imp, i) => (
                  <div key={i} className="flex items-center gap-1.5 mb-0.5">
                    <ArrowRight size={8} className="text-[#00E5C0] flex-shrink-0" />
                    <span className="text-[12px] text-[#B0B8C4] truncate">{imp}</span>
                  </div>
                ))}
                <div className="flex items-center gap-2 mt-1">
                  {event.provider_name && <span className="text-[10px] text-[#3A4150]">{event.provider_name}</span>}
                  <span className="text-[10px] text-[#2A2F38]">{timeAgo(event.created_at)}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
